import { RoleActions } from './../ActionTypes';

export const setAllRoles = (roles) => ({
    type: RoleActions.SetAll,
    roles
});
